import * as i0 from '@angular/core';
import { Injectable, Component, Input, NgModule } from '@angular/core';
import { pluck, map, takeUntil, take } from 'rxjs/operators';
import * as i1 from '@angular/common/http';
import * as i1$1 from '@angular/forms';
import { Validators, FormControl, FormGroup, ControlContainer, FormGroupDirective, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { USER_PERMISSIONS } from 'app-models';
import { Subject, combineLatest } from 'rxjs';
import * as errorUtils from 'error-message-utility';
import * as i3 from 'reference-library';
import * as i4 from '@angular/common';
import * as i5 from 'primeng/dropdown';
import * as i6 from 'primeng/api';
import * as i7 from 'primeng/inputnumber';
import * as i8 from 'primeng/inputtextarea';
import * as i9 from 'primeng/radiobutton';
import * as i10 from 'primeng/inputtext';
import * as i11 from 'primeng/multiselect';
import { PrimengLibraryModule } from 'primeng-library';

class SubTaskPetitionDetailsService {
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
    getPetitionerClientList(companyId, countryType = '') {
        let apiUrl = `/company/${companyId}/hierarchy`;
        if (countryType !== '') {
            apiUrl = `${apiUrl}?${countryType}=USA`;
        }
        return this.httpClient.get(apiUrl).pipe(pluck('data'), map((data) => {
            return data;
        }));
    }
    getForeignCompanyListForEVisa(visaType, companyId) {
        return this.httpClient.get(`/${visaType}/company/${companyId}/list`).pipe(pluck('data'), map((data) => {
            let returnResult = [];
            if (data && data.length > 0) {
                returnResult = data.map(x => {
                    return Object.assign(Object.assign({}, x), { id: x.companyId });
                });
            }
            return returnResult;
        }));
    }
    getTaskQuestioneryOnCategory(quesCategory) {
        return this.httpClient.get(`/question/category/${quesCategory}`).pipe(map((response) => response.data));
    }
    getEmployeeDetails(companyId, employeeId) {
        return this.httpClient.get(`/company/${companyId}/employee/${employeeId}`).pipe(pluck('data'), map((data) => {
            return data;
        }));
    }
    getUsersOfCompany(companyId) {
        return this.httpClient.get('/company/' + companyId + '/employee').pipe(map((response) => response.data));
    }
    getReviewersUser(companyId, permissionName, isOnlySignatory) {
        const params = isOnlySignatory ? `&isOnlySignatory=${isOnlySignatory}` : '';
        return this.httpClient.get(`/company/${companyId}/employee?permissionName=${permissionName}${params}`).pipe(map((response) => response.data));
    }
    getActiveAttorneyCompanyList(petCompanyId) {
        return this.httpClient.get(`/petitioner/${petCompanyId}/attorney/list`).pipe(map((response) => response.data));
    }
    // premium
    getServiceCenters(isPremium, visaType, petitionType) {
        return this.httpClient.get(`/serviceCenter/${isPremium}/visaType/${visaType}/petitionType/${petitionType}`).pipe(map((response) => response.data));
    }
    getImmiServiceCenters(isPremium, taskTypeId) {
        return this.httpClient.get(`/taskType/${taskTypeId}/serviceCenter/${isPremium}`).pipe(map((response) => response.data));
    }
}
SubTaskPetitionDetailsService.ɵfac = function SubTaskPetitionDetailsService_Factory(t) { return new (t || SubTaskPetitionDetailsService)(i0.ɵɵinject(i1.HttpClient)); };
SubTaskPetitionDetailsService.ɵprov = i0.ɵɵdefineInjectable({ token: SubTaskPetitionDetailsService, factory: SubTaskPetitionDetailsService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SubTaskPetitionDetailsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

function SubTaskPetitionDetailsComponent_div_3_div_1_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r20 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 24);
    i0.ɵɵelementStart(1, "mat-slide-toggle", 25);
    i0.ɵɵlistener("toggleChange", function SubTaskPetitionDetailsComponent_div_3_div_1_div_5_Template_mat_slide_toggle_toggleChange_1_listener() { i0.ɵɵrestoreView(_r20); const ctx_r19 = i0.ɵɵnextContext(); const i_r14 = ctx_r19.index; const a_r13 = ctx_r19.$implicit; const ctx_r18 = i0.ɵɵnextContext(2); return ctx_r18.onQuestionToggle(i_r14, a_r13.get("answer").value); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function SubTaskPetitionDetailsComponent_div_3_div_1_div_6_div_1_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 30);
    i0.ɵɵtext(1, " Required ");
    i0.ɵɵelementEnd();
} }
function SubTaskPetitionDetailsComponent_div_3_div_1_div_6_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 28);
    i0.ɵɵelementStart(1, "label", 8);
    i0.ɵɵtext(2, "How many?");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "p-inputNumber", 29);
    i0.ɵɵtemplate(4, SubTaskPetitionDetailsComponent_div_3_div_1_div_6_div_1_span_4_Template, 2, 0, "span", 12);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const a_r13 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("min", 1)("max", 99)("maxlength", 2)("useGrouping", false);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", a_r13.get("additionalInfo").touched && a_r13.errors && a_r13.errors["additionalInfoIsRequired"]);
} }
function SubTaskPetitionDetailsComponent_div_3_div_1_div_6_div_2_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 30);
    i0.ɵɵtext(1, " Required ");
    i0.ɵɵelementEnd();
} }
function SubTaskPetitionDetailsComponent_div_3_div_1_div_6_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 31);
    i0.ɵɵelementStart(1, "label", 8);
    i0.ɵɵtext(2, "Explanation");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "textarea", 32);
    i0.ɵɵtemplate(4, SubTaskPetitionDetailsComponent_div_3_div_1_div_6_div_2_span_4_Template, 2, 0, "span", 12);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const a_r13 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", a_r13.get("additionalInfo").touched && a_r13.errors && a_r13.errors["additionalInfoIsRequired"]);
} }
function SubTaskPetitionDetailsComponent_div_3_div_1_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵtemplate(1, SubTaskPetitionDetailsComponent_div_3_div_1_div_6_div_1_Template, 5, 5, "div", 26);
    i0.ɵɵtemplate(2, SubTaskPetitionDetailsComponent_div_3_div_1_div_6_div_2_Template, 5, 1, "div", 27);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r14 = i0.ɵɵnextContext().index;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", i_r14 === 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", i_r14 === 1);
} }
function SubTaskPetitionDetailsComponent_div_3_div_1_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 33);
    i0.ɵɵelement(1, "input", 34);
    i0.ɵɵelementEnd();
} }
function SubTaskPetitionDetailsComponent_div_3_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵelementStart(1, "div", 18);
    i0.ɵɵelementStart(2, "div", 19);
    i0.ɵɵelementStart(3, "div", 20);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, SubTaskPetitionDetailsComponent_div_3_div_1_div_5_Template, 2, 0, "div", 21);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, SubTaskPetitionDetailsComponent_div_3_div_1_div_6_Template, 3, 2, "div", 22);
    i0.ɵɵtemplate(7, SubTaskPetitionDetailsComponent_div_3_div_1_div_7_Template, 2, 0, "div", 23);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const a_r13 = ctx.$implicit;
    const i_r14 = ctx.index;
    const ctx_r12 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("formGroupName", i_r14);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r12.questionList[i_r14] == null ? null : ctx_r12.questionList[i_r14].question, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r12.questionList[i_r14].isBoolean == 1 || ctx_r12.questionList[i_r14].isBoolean);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r12.fields.showAdditionalAnswerForQuestions && a_r13.get("answer").value);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r12.questionList[i_r14].isBoolean || ctx_r12.questionList[i_r14].isBoolean == 0);
} }
function SubTaskPetitionDetailsComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, SubTaskPetitionDetailsComponent_div_3_div_1_Template, 8, 5, "div", 16);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r0.getFormQuestionsArray());
} }
function SubTaskPetitionDetailsComponent_div_4_span_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 30);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r28 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r28.getGlobalErrorMessages("REQUIRED"), " ");
} }
function SubTaskPetitionDetailsComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵelementStart(1, "div", 35);
    i0.ɵɵelementStart(2, "label", 13);
    i0.ɵɵtext(3, "Type of Beneficiaries Requested ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 36);
    i0.ɵɵelementStart(5, "div", 37);
    i0.ɵɵelement(6, "p-radioButton", 38);
    i0.ɵɵelementStart(7, "label", 39);
    i0.ɵɵtext(8, "Named");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 37);
    i0.ɵɵelement(10, "p-radioButton", 40);
    i0.ɵɵelementStart(11, "label", 41);
    i0.ɵɵtext(12, "Unnamed (for H-2A or H-2B petition only)");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(13, SubTaskPetitionDetailsComponent_div_4_span_13_Template, 2, 1, "span", 12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(13);
    i0.ɵɵproperty("ngIf", ctx_r1.petitionTaskForm.get("beneficiaryType").touched && (ctx_r1.petitionTaskForm.get("beneficiaryType").errors == null ? null : ctx_r1.petitionTaskForm.get("beneficiaryType").errors.required));
} }
function SubTaskPetitionDetailsComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 5);
} }
function SubTaskPetitionDetailsComponent_div_6_div_1_small_4_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "There are no associated companies having non-US incorporation country.");
    i0.ɵɵelementEnd();
} }
function SubTaskPetitionDetailsComponent_div_6_div_1_small_4_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "There are no associated companies in the treaty countries for the selected visa.");
    i0.ɵɵelementEnd();
} }
const _c0 = function () { return ["L1A", "L1B"]; };
const _c1 = function () { return ["E1", "E2", "E2C"]; };
function SubTaskPetitionDetailsComponent_div_6_div_1_small_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "small", 45);
    i0.ɵɵtemplate(1, SubTaskPetitionDetailsComponent_div_6_div_1_small_4_span_1_Template, 2, 0, "span", 2);
    i0.ɵɵtemplate(2, SubTaskPetitionDetailsComponent_div_6_div_1_small_4_span_2_Template, 2, 0, "span", 2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r32 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", i0.ɵɵpureFunction0(2, _c0).includes(ctx_r32.visaType));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", i0.ɵɵpureFunction0(3, _c1).includes(ctx_r32.visaType));
} }
function SubTaskPetitionDetailsComponent_div_6_div_1_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 30);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r33 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r33.getGlobalErrorMessages("REQUIRED"), " ");
} }
function SubTaskPetitionDetailsComponent_div_6_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r37 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵelementStart(1, "label", 8);
    i0.ɵɵtext(2, "Foreign Company");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "p-dropdown", 43);
    i0.ɵɵlistener("onChange", function SubTaskPetitionDetailsComponent_div_6_div_1_Template_p_dropdown_onChange_3_listener() { i0.ɵɵrestoreView(_r37); const ctx_r36 = i0.ɵɵnextContext(2); return ctx_r36.onForeignCompanyChange(); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, SubTaskPetitionDetailsComponent_div_6_div_1_small_4_Template, 3, 4, "small", 44);
    i0.ɵɵtemplate(5, SubTaskPetitionDetailsComponent_div_6_div_1_span_5_Template, 2, 1, "span", 12);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r29 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("options", ctx_r29.foreignCompanyList);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r29.foreignCompanyList || ctx_r29.foreignCompanyList && ctx_r29.foreignCompanyList.length === 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r29.petitionTaskForm.get("foreignCompanyId").touched && (ctx_r29.petitionTaskForm.get("foreignCompanyId").errors == null ? null : ctx_r29.petitionTaskForm.get("foreignCompanyId").errors.required));
} }
function SubTaskPetitionDetailsComponent_div_6_div_2_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 30);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r38 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r38.getGlobalErrorMessages("REQUIRED"), " ");
} }
function SubTaskPetitionDetailsComponent_div_6_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵelementStart(1, "label", 8);
    i0.ɵɵtext(2, "Relationship of US Company with Company abroad");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "p-dropdown", 46);
    i0.ɵɵtemplate(4, SubTaskPetitionDetailsComponent_div_6_div_2_span_4_Template, 2, 1, "span", 12);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r30 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("options", ctx_r30.companyRelationList);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r30.petitionTaskForm.get("companyRelationCode").touched && (ctx_r30.petitionTaskForm.get("companyRelationCode").errors == null ? null : ctx_r30.petitionTaskForm.get("companyRelationCode").errors.required));
} }
function SubTaskPetitionDetailsComponent_div_6_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵelementStart(1, "label", 13);
    i0.ɵɵtext(2, "Treaty Country");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "input", 47);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("readonly", true);
} }
function SubTaskPetitionDetailsComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵtemplate(1, SubTaskPetitionDetailsComponent_div_6_div_1_Template, 6, 3, "div", 42);
    i0.ɵɵtemplate(2, SubTaskPetitionDetailsComponent_div_6_div_2_Template, 5, 2, "div", 42);
    i0.ɵɵtemplate(3, SubTaskPetitionDetailsComponent_div_6_div_3_Template, 4, 1, "div", 42);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.fields.showForeignCompany);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.fields.showRelationshipOfUSCompanyWithForeignCompany);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.fields.showTreatyCountry);
} }
function SubTaskPetitionDetailsComponent_ng_template_13_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r39 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate((ctx_r39.selectedSignatory == null ? null : ctx_r39.selectedSignatory.firstName) + " " + (ctx_r39.selectedSignatory == null ? null : ctx_r39.selectedSignatory.lastName));
} }
function SubTaskPetitionDetailsComponent_ng_template_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, SubTaskPetitionDetailsComponent_ng_template_13_div_0_Template, 3, 1, "div", 2);
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r4.selectedSignatory);
} }
function SubTaskPetitionDetailsComponent_ng_template_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const employee_r40 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate((employee_r40 == null ? null : employee_r40.firstName) + " " + (employee_r40 == null ? null : employee_r40.lastName));
} }
function SubTaskPetitionDetailsComponent_span_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 30);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r6.getGlobalErrorMessages("REQUIRED"), " ");
} }
function SubTaskPetitionDetailsComponent_div_21_ng_template_10_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r43 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate((ctx_r43.selectedPreparer == null ? null : ctx_r43.selectedPreparer.firstName) + " " + (ctx_r43.selectedPreparer == null ? null : ctx_r43.selectedPreparer.lastName));
} }
function SubTaskPetitionDetailsComponent_div_21_ng_template_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, SubTaskPetitionDetailsComponent_div_21_ng_template_10_div_0_Template, 3, 1, "div", 2);
} if (rf & 2) {
    const ctx_r41 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngIf", ctx_r41.selectedPreparer);
} }
function SubTaskPetitionDetailsComponent_div_21_ng_template_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const employee_r44 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate((employee_r44 == null ? null : employee_r44.firstName) + " " + (employee_r44 == null ? null : employee_r44.lastName));
} }
function SubTaskPetitionDetailsComponent_div_21_Template(rf, ctx) { if (rf & 1) {
    const _r46 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 6);
    i0.ɵɵelementStart(2, "div", 7);
    i0.ɵɵelementStart(3, "label", 13);
    i0.ɵɵtext(4, "Lawfirm");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "p-dropdown", 48);
    i0.ɵɵlistener("onChange", function SubTaskPetitionDetailsComponent_div_21_Template_p_dropdown_onChange_5_listener() { i0.ɵɵrestoreView(_r46); const ctx_r45 = i0.ɵɵnextContext(); return ctx_r45.attorneySelected(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 7);
    i0.ɵɵelementStart(7, "label", 13);
    i0.ɵɵtext(8, "Preparer Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "p-dropdown", 49);
    i0.ɵɵlistener("onChange", function SubTaskPetitionDetailsComponent_div_21_Template_p_dropdown_onChange_9_listener() { i0.ɵɵrestoreView(_r46); const ctx_r47 = i0.ɵɵnextContext(); return ctx_r47.userPreparerSelected(); });
    i0.ɵɵtemplate(10, SubTaskPetitionDetailsComponent_div_21_ng_template_10_Template, 1, 1, "ng-template", 10);
    i0.ɵɵtemplate(11, SubTaskPetitionDetailsComponent_div_21_ng_template_11_Template, 3, 1, "ng-template", 11);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("options", ctx_r7.attorneys);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("options", ctx_r7.attorneyUsers);
} }
function SubTaskPetitionDetailsComponent_div_22_ng_template_13_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r52 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate((ctx_r52.selectedPreparer == null ? null : ctx_r52.selectedPreparer.firstName) + " " + (ctx_r52.selectedPreparer == null ? null : ctx_r52.selectedPreparer.lastName));
} }
function SubTaskPetitionDetailsComponent_div_22_ng_template_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, SubTaskPetitionDetailsComponent_div_22_ng_template_13_div_0_Template, 3, 1, "div", 2);
} if (rf & 2) {
    const ctx_r48 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngIf", ctx_r48.selectedPreparer);
} }
function SubTaskPetitionDetailsComponent_div_22_ng_template_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const employee_r53 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate((employee_r53 == null ? null : employee_r53.firstName) + " " + (employee_r53 == null ? null : employee_r53.lastName));
} }
function SubTaskPetitionDetailsComponent_div_22_ng_template_19_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r54 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r54.selectedLawFirmUsersTextArr.join(", "));
} }
function SubTaskPetitionDetailsComponent_div_22_ng_template_19_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1, "Select");
    i0.ɵɵelementEnd();
} }
function SubTaskPetitionDetailsComponent_div_22_ng_template_19_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, SubTaskPetitionDetailsComponent_div_22_ng_template_19_div_0_Template, 2, 1, "div", 2);
    i0.ɵɵtemplate(1, SubTaskPetitionDetailsComponent_div_22_ng_template_19_div_1_Template, 2, 0, "div", 2);
} if (rf & 2) {
    const ctx_r50 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngIf", ctx_r50.selectedLawFirmUsers.length);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r50.selectedLawFirmUsers.length);
} }
function SubTaskPetitionDetailsComponent_div_22_ng_template_20_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const employee_r56 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate((employee_r56 == null ? null : employee_r56.firstName) + " " + (employee_r56 == null ? null : employee_r56.lastName));
} }
function SubTaskPetitionDetailsComponent_div_22_Template(rf, ctx) { if (rf & 1) {
    const _r58 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "h5", 50);
    i0.ɵɵtext(2, "Lawfirm Details ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 19);
    i0.ɵɵelementStart(4, "div", 51);
    i0.ɵɵelementStart(5, "label", 52);
    i0.ɵɵtext(6, "Firm Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 53);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 7);
    i0.ɵɵelementStart(10, "label", 54);
    i0.ɵɵtext(11, "Authorized Signatory");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "p-dropdown", 55);
    i0.ɵɵlistener("onChange", function SubTaskPetitionDetailsComponent_div_22_Template_p_dropdown_onChange_12_listener() { i0.ɵɵrestoreView(_r58); const ctx_r57 = i0.ɵɵnextContext(); return ctx_r57.userPreparerSelected(); });
    i0.ɵɵtemplate(13, SubTaskPetitionDetailsComponent_div_22_ng_template_13_Template, 1, 1, "ng-template", 10);
    i0.ɵɵtemplate(14, SubTaskPetitionDetailsComponent_div_22_ng_template_14_Template, 3, 1, "ng-template", 11);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "div", 7);
    i0.ɵɵelementStart(16, "label", 56);
    i0.ɵɵtext(17, "Law Firm Users");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "p-multiSelect", 57);
    i0.ɵɵlistener("onChange", function SubTaskPetitionDetailsComponent_div_22_Template_p_multiSelect_onChange_18_listener() { i0.ɵɵrestoreView(_r58); const ctx_r59 = i0.ɵɵnextContext(); return ctx_r59.usersLawFrimSelected(); });
    i0.ɵɵtemplate(19, SubTaskPetitionDetailsComponent_div_22_ng_template_19_Template, 2, 2, "ng-template", 58);
    i0.ɵɵtemplate(20, SubTaskPetitionDetailsComponent_div_22_ng_template_20_Template, 2, 1, "ng-template", 11);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext();
    i0.ɵɵadvance(8);
    i0.ɵɵtextInterpolate1(" ", (ctx_r8.employeeDetails == null ? null : ctx_r8.employeeDetails.companyName) ? ctx_r8.employeeDetails == null ? null : ctx_r8.employeeDetails.companyName : "--", " ");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("options", ctx_r8.attorneyUsers);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("options", ctx_r8.lawFirmUsersList);
} }
function SubTaskPetitionDetailsComponent_ng_template_29_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r60 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate((ctx_r60.selectedPetetionPreprarer == null ? null : ctx_r60.selectedPetetionPreprarer.firstName) ? (ctx_r60.selectedPetetionPreprarer == null ? null : ctx_r60.selectedPetetionPreprarer.firstName) + " " + (ctx_r60.selectedPetetionPreprarer == null ? null : ctx_r60.selectedPetetionPreprarer.lastName) : "--");
} }
function SubTaskPetitionDetailsComponent_ng_template_29_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, SubTaskPetitionDetailsComponent_ng_template_29_div_0_Template, 3, 1, "div", 2);
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r9.selectedPetetionPreprarer);
} }
function SubTaskPetitionDetailsComponent_ng_template_30_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const employee_r61 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate((employee_r61 == null ? null : employee_r61.firstName) + " " + (employee_r61 == null ? null : employee_r61.lastName));
} }
function SubTaskPetitionDetailsComponent_span_31_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 30);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r11.getGlobalErrorMessages("REQUIRED"), " ");
} }
class SubTaskPetitionDetailsComponent {
    constructor(fb, apiService, referenceLibraryService, parentFor) {
        this.fb = fb;
        this.apiService = apiService;
        this.referenceLibraryService = referenceLibraryService;
        this.parentFor = parentFor;
        this.serviceCenters = [];
        this.reviewUsersList = [];
        this.attorneys = [];
        this.attorneyUsers = [];
        this.users = [];
        this.isOutsideImagility = true;
        this.petitionUpdates = [false, false];
        this.foreignCompanyList = [];
        this.companyRelationList = [];
        this.fieldExtrAbltyCodeList = [];
        this.extraBLDOCEVDNCATGList = [];
        this.majorInternationAwardList = [];
        this.applicableOptionItem = [{
                code: String,
                name: String,
                description: String
            }];
        this.ngUnsubscribe = new Subject();
        this.fields = {
            showAdditionalAnswerForQuestions: false,
            showDividerBeforeForeignCompany: false,
            showForeignCompany: false,
            showRelationshipOfUSCompanyWithForeignCompany: false,
            showTreatyCountry: false,
            showBeneficiaryType: false
        };
        this.additionalInfoTextAnswerRequiredVisaTypeArray = ['L1A', 'L1B', 'E1', 'E2', 'E2C', 'O1A', 'O1B', 'TN1', 'TN2'];
        this.subTaskDetails = null;
        this.lawFirmUsersList = [];
        this.selectedLawFirmUsers = [];
        this.selectedLawFirmUsersTextArr = [];
    }
    ngOnInit() {
        this.petitionTaskForm = this.fb.group({
            authorizedSignatoryId: [null, Validators.required],
            processingType: [null],
            serviceCenterId: [null],
            attorneyId: [null],
            immSpecialistId: [null, Validators.required],
            preparerAttorneyId: [null],
            immigrantTypeCode: [null],
            isAttorneySame: [0],
            isCaseTransferred: [0],
            selectedDesignation: [null],
            questionAndResponseDTO: this.fb.array([]),
            lawFirmUsers: [null]
        });
        // console.log('subtaskDetails:', this.subTaskDetails);
        this.form = this.parentFor.form;
        this.form.addControl('petitionTaskForm', this.petitionTaskForm);
        //this.visaType = this.form.get('newTaskForm').get('visaType') && this.form.get('newTaskForm').get('visaType').value ? this.form.get('newTaskForm').get('visaType').value : 'H1-B';
        switch (this.form.get('newTaskForm') && this.form.get('newTaskForm').get('visaType') && this.form.get('newTaskForm').get('visaType').value) {
            case 'L1A':
            case 'L1B':
                this.petitionTaskForm.patchValue({
                    immigrantTypeCode: 'VISA'
                });
                this.petitionTaskForm.addControl('companyRelationCode', new FormControl(null, Validators.required));
                this.petitionTaskForm.addControl('foreignCompanyId', new FormControl(null, Validators.required));
                this.fields = {
                    showAdditionalAnswerForQuestions: true,
                    showDividerBeforeForeignCompany: true,
                    showForeignCompany: true,
                    showRelationshipOfUSCompanyWithForeignCompany: true,
                    showTreatyCountry: false,
                    showBeneficiaryType: false
                };
                break;
            case 'E1':
            case 'E2':
            case 'E2C':
                this.petitionTaskForm.patchValue({
                    immigrantTypeCode: 'VISA'
                });
                this.petitionTaskForm.addControl('companyRelationCode', new FormControl(null, Validators.required));
                this.petitionTaskForm.addControl('foreignCompanyId', new FormControl(null, Validators.required));
                this.petitionTaskForm.addControl('treatyCountry', new FormControl(null));
                this.fields = {
                    showAdditionalAnswerForQuestions: true,
                    showDividerBeforeForeignCompany: true,
                    showForeignCompany: true,
                    showRelationshipOfUSCompanyWithForeignCompany: true,
                    showTreatyCountry: true,
                    showBeneficiaryType: false
                };
                break;
            case 'O1A':
            case 'O1B':
                this.petitionTaskForm.addControl('fieldExtrAbltyCode', new FormControl(null, Validators.required));
                this.petitionTaskForm.addControl('extrAblDocEvdCatgCode', new FormControl('', Validators.required));
                this.petitionTaskForm.addControl('applicableOptionIds', this.fb.array([]));
                this.petitionTaskForm.addControl('applicableOptionCodes', this.fb.array([]));
                // this.petitionTaskForm.setValidators(this.applicableOptionIdsRequired());
                this.fields = {
                    showAdditionalAnswerForQuestions: true,
                    showDividerBeforeForeignCompany: false,
                    showForeignCompany: false,
                    showRelationshipOfUSCompanyWithForeignCompany: false,
                    showTreatyCountry: false,
                    showBeneficiaryType: false
                };
                this.getExtraOrdinaryDetailsOVisa();
                break;
            case 'TN1':
            case 'TN2':
                this.fields = {
                    showAdditionalAnswerForQuestions: true,
                    showDividerBeforeForeignCompany: false,
                    showForeignCompany: false,
                    showRelationshipOfUSCompanyWithForeignCompany: false,
                    showTreatyCountry: false,
                    showBeneficiaryType: false
                };
                break;
            case 'E3':
            case 'H3A':
                this.petitionTaskForm.addControl('beneficiaryType', new FormControl({ value: 'named', disabled: true }));
                this.fields = {
                    showAdditionalAnswerForQuestions: false,
                    showDividerBeforeForeignCompany: false,
                    showForeignCompany: false,
                    showRelationshipOfUSCompanyWithForeignCompany: false,
                    showTreatyCountry: false,
                    showBeneficiaryType: true
                };
                break;
            default:
                this.fields = {
                    showAdditionalAnswerForQuestions: false,
                    showDividerBeforeForeignCompany: false,
                    showForeignCompany: false,
                    showRelationshipOfUSCompanyWithForeignCompany: false,
                    showTreatyCountry: false,
                    showBeneficiaryType: false
                };
                break;
        }
        // if (this.petitionTaskForm) {
        //   for (const [key, value] of Object.entries(this.petitionTaskForm.controls)) {
        //     this.form.addControl(key, value);
        //   }
        // }
        this.userType = sessionStorage.getItem('userTypeRole');
        this.primaryCompanyId = parseInt(this.form.get('newTaskForm').get('companyId').value);
        let isOnlySignatory = true; // to load the signatory users
        this.form.controls['newTaskForm'].controls['companyId'].valueChanges.subscribe((data) => {
            combineLatest([
                this.apiService.getReviewersUser(this.form.get('newTaskForm').get('companyId').value, USER_PERMISSIONS.PETITION_REVIEWER, isOnlySignatory),
                this.apiService.getActiveAttorneyCompanyList(this.form.get('newTaskForm').get('companyId').value),
                this.apiService.getUsersOfCompany(this.form.get('newTaskForm').get('companyId').value),
                this.referenceLibraryService.getReferenceData('USFORGNCOMPREL')
            ])
                .pipe(takeUntil(this.ngUnsubscribe))
                .subscribe(data => {
                var _a;
                this.reviewUsersList = data[0];
                this.attorneys = data[1];
                this.users = data[2];
                this.companyRelationList = data[3];
                this.petitionTaskForm.patchValue({
                    authorizedSignatoryId: this.subTaskDetails && this.subTaskDetails.signatoryId ? this.subTaskDetails.signatoryId : null,
                    selectedDesignation: '',
                    immSpecialistId: this.subTaskDetails && this.subTaskDetails.immSpecialistId ? this.subTaskDetails.immSpecialistId : null,
                    processingType: this.subTaskDetails && this.subTaskDetails.processingType
                });
                if (this.subTaskDetails) {
                    if (this.subTaskDetails.signatoryId) {
                        this.userSelected();
                    }
                    if (this.subTaskDetails.processingType) {
                        this.onChangeProcessingType();
                    }
                    if (this.subTaskDetails.immSpecialistId) {
                        this.onPetitionerPreparerSelected();
                    }
                    if (((_a = this.subTaskDetails) === null || _a === void 0 ? void 0 : _a.beneficiaryType) && this.fields.showBeneficiaryType) {
                        this.petitionTaskForm.patchValue({
                            beneficiaryType: this.subTaskDetails.beneficiaryType
                        });
                    }
                }
                if (this.userType !== 'Attorney') {
                    this.petitionTaskForm.patchValue({
                        attorneyId: this.subTaskDetails && this.subTaskDetails.attorneyId ? this.subTaskDetails.attorneyId : null,
                        preparerAttorneyId: this.subTaskDetails && this.subTaskDetails.preparerAttorneyId ? this.subTaskDetails.preparerAttorneyId : 0
                    });
                    if (this.subTaskDetails && this.subTaskDetails.attorneyId) {
                        this.attorneySelected();
                    }
                    this.isAttorneySelect = true;
                    switch (this.form.get('newTaskForm') && this.form.get('newTaskForm').get('visaType') && this.form.get('newTaskForm').get('visaType').value) {
                        case 'L1A':
                        case 'L1B':
                            this.apiService.getPetitionerClientList(this.form.get('newTaskForm').get('companyId').value, 'notInCountry')
                                .pipe(take(1))
                                .subscribe((response) => {
                                this.foreignCompanyList = response;
                                this.getQuestionListForCreateTask();
                            });
                            break;
                        case 'E1':
                        case 'E2':
                        case 'E2C':
                            this.apiService.getForeignCompanyListForEVisa(this.form.get('newTaskForm').get('visaType').value, this.form.get('newTaskForm').get('companyId').value)
                                .pipe(take(1))
                                .subscribe((response) => {
                                this.foreignCompanyList = response;
                                this.getQuestionListForCreateTask();
                            });
                            break;
                        default:
                            this.getQuestionListForCreateTask();
                    }
                }
                else {
                    this.isAttorneySelect = false;
                    if (this.form.get('newTaskForm').get('companyId').value) {
                        this.getForeignCompanyListForAttorney();
                    }
                    this.apiService.getEmployeeDetails(parseInt(sessionStorage.getItem('companyId')), parseInt(sessionStorage.getItem('employeeId')))
                        .pipe(take(1))
                        .subscribe((response) => {
                        this.employeeDetails = response;
                        //sessionStorage.setItem("setPreparerAttorneyId", this.employeeDetails['id']);
                        this.petitionTaskForm.patchValue({
                            attorneyId: response.companyId,
                        });
                        this.attorneySelected();
                        this.getQuestionListForCreateTask();
                    });
                }
            });
        });
    }
    onForeignCompanyChange() {
        if (['E1', 'E2', 'E2C'].includes(this.form.get('newTaskForm').get('visaType').value)) {
            this.petitionTaskForm.patchValue({
                treatyCountry: this.foreignCompanyList.find(x => x.id === this.petitionTaskForm.get('foreignCompanyId').value).countryName
            });
        }
    }
    get applicableOptionGroups() {
        return this.petitionTaskForm.get('applicableOptionIds').controls;
    }
    clickRadioBtn(extrAblDocEvdCatgCode) {
        this.petitionTaskForm.get('applicableOptionIds').patchValue(this.petitionTaskForm.get('applicableOptionIds').value.map((x, i) => {
            if (x) {
                this.updateCheckedOptions(false, this.majorInternationAwardList[i].code);
            }
            return false;
        }));
    }
    updateCheckedOptions(checked, code) {
        const applicableOptionIds = this.petitionTaskForm.get('applicableOptionCodes').value;
        if (checked) {
            if (!applicableOptionIds.includes(code)) {
                this.petitionTaskForm.get('applicableOptionCodes').push(new FormControl(code));
            }
        }
        else {
            if (applicableOptionIds.includes(code)) {
                this.petitionTaskForm.get('applicableOptionCodes').removeAt(applicableOptionIds.indexOf(code));
            }
        }
    }
    getExtraOrdinaryDetailsOVisa() {
        let fieldExtrAbltyCode;
        let payload;
        if (this.form.get('newTaskForm').get('visaType').value === 'O1A') {
            fieldExtrAbltyCode = 'O1AFLDEXTRABL';
            payload = ['OTHERDOCEVDN'];
        }
        else {
            fieldExtrAbltyCode = 'O1BFLDEXTRABL';
            payload = ['OTHERDOCEVDN', 'O1BSPECDOCEVDN'];
        }
        combineLatest([
            this.referenceLibraryService.getReferenceData('EXTRABLDOCEVDNCATG'),
            this.referenceLibraryService.postReferenceData(payload),
            this.referenceLibraryService.getReferenceData(fieldExtrAbltyCode)
        ]).pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(data => {
            this.extraBLDOCEVDNCATGList = data[0];
            this.majorInternationAwardList = data[1];
            const applicableOptionIdsFormArray = this.petitionTaskForm.get('applicableOptionIds');
            applicableOptionIdsFormArray.clear();
            this.majorInternationAwardList.forEach(() => {
                applicableOptionIdsFormArray.push(new FormControl(false));
            });
            // console.log(applicableOptionIdsFormArray.value);
            this.fieldExtrAbltyCodeList = data[2];
            this.petitionTaskForm.patchValue({
                extrAblDocEvdCatgCode: this.extraBLDOCEVDNCATGList[0].code
            });
        });
    }
    getForeignCompanyListForAttorney() {
        switch (this.form.get('newTaskForm').get('visaType').value) {
            case 'L1A':
            case 'L1B':
                this.apiService.getPetitionerClientList(this.form.get('newTaskForm').get('companyId').value, 'notInCountry')
                    .pipe(take(1))
                    .subscribe((response) => {
                    this.foreignCompanyList = response;
                });
                break;
            case 'E1':
            case 'E2':
            case 'E2C':
                this.apiService.getForeignCompanyListForEVisa(this.form.get('newTaskForm').get('visaType').value, this.form.get('newTaskForm').get('companyId').value)
                    .pipe(take(1))
                    .subscribe((response) => {
                    this.foreignCompanyList = response;
                });
                break;
        }
    }
    getFormQuestionsArray() {
        return this.petitionTaskForm.get('questionAndResponseDTO').controls;
    }
    getQuestionListForCreateTask() {
        var _a;
        this.isOutsideImagility = (_a = this.form.get('isOutsideImagility')) === null || _a === void 0 ? void 0 : _a.value;
        let quesCategory;
        switch (this.form.get('newTaskForm').get('visaType').value) {
            case 'H1-B':
                quesCategory = 'TASKQUES';
                break;
            default:
                quesCategory = 'VISAQUECTGTYP';
                break;
        }
        this.apiService.getTaskQuestioneryOnCategory(quesCategory)
            .pipe(take(1))
            .subscribe((response) => {
            this.questionList = response.map((item) => {
                return Object.assign(Object.assign({}, item), { answer: !!(item.answer && item.answer === 1) });
            });
            const questionAndResponseDTO = this.form.get('questionAndResponseDTO');
            questionAndResponseDTO.clear();
            this.questionList.forEach((x, index) => {
                questionAndResponseDTO.push(this.createQuestionList(x));
            });
        });
    }
    createQuestionList(item) {
        const savedItem = this.subTaskDetails && this.subTaskDetails.questionAndResponseDTO.find((x) => x.id === item.id || (!item.questionId && x.questionId === item.id));
        return new FormGroup({
            answer: new FormControl(savedItem ? Boolean(savedItem.answer) : item.answer),
            id: new FormControl(item.response && item.response.id ? item.response.id : null),
            questionId: new FormControl(item.id),
            isBoolean: new FormControl(true),
            additionalInfo: new FormControl(savedItem ? savedItem.additionalInfo : null),
            sequenceNumber: new FormControl(item.sequenceNumber),
            question: new FormControl(item.question)
        }, this.additionalInfoRequired.bind(this));
    }
    additionalInfoRequired(group) {
        if (!this.isOutsideImagility && this.additionalInfoTextAnswerRequiredVisaTypeArray.includes(this.form.get('newTaskForm').get('visaType').value) &&
            group.value.answer && !group.value.additionalInfo) {
            return { additionalInfoIsRequired: true };
        }
        return null;
    }
    onQuestionToggle(questionIndex, answer) {
        if (!answer) {
            const questionGroup = this.form.get('questionAndResponseDTO').controls[questionIndex];
            questionGroup.patchValue({
                additionalInfo: null
            });
        }
    }
    onChangeProcessingType() {
        this.serviceCenters = [];
        this.getServiceCenter();
    }
    getServiceCenter() {
        const processingType = this.petitionTaskForm.get('processingType').value;
        const petitionType = this.form.get('newTaskForm').get('petitionType').value;
        if (this.templateTaskTypeId) {
            this.apiService.getImmiServiceCenters((processingType === 'regular') ? 'false' : 'true', this.templateTaskTypeId)
                .subscribe((data) => {
                this.serviceCenters = data;
                if (this.subTaskDetails && this.subTaskDetails.serviceCenterId) {
                    this.petitionTaskForm.patchValue({ serviceCenterId: this.subTaskDetails.serviceCenterId });
                }
            });
        }
        else {
            this.apiService.getServiceCenters((processingType === 'regular') ? 'false' : 'true', this.form.get('newTaskForm').get('visaType').value, petitionType)
                .subscribe((data) => {
                this.serviceCenters = data;
            });
        }
    }
    userSelected() {
        const id = this.petitionTaskForm.get('authorizedSignatoryId').value;
        this.selectedSignatory = this.reviewUsersList.find(ele => ele.id === id);
        this.petitionTaskForm.patchValue({
            selectedDesignation: this.selectedSignatory.designation,
        });
        this.selectedDesignation = this.selectedSignatory.designation;
    }
    getGlobalErrorMessages(error) {
        return errorUtils.errorMessages.get(error);
    }
    attorneySelected() {
        const attorneyId = this.petitionTaskForm.get('attorneyId').value;
        if (attorneyId && attorneyId !== '') {
            combineLatest([
                this.apiService.getReviewersUser(attorneyId, USER_PERMISSIONS.PETITION_REVIEWER),
                this.apiService.getUsersOfCompany(attorneyId),
            ])
                .pipe(takeUntil(this.ngUnsubscribe))
                .subscribe(data => {
                this.attorneyUsers = data ? data[0] : [];
                this.lawFirmUsersList = data ? data[1] : [];
                if (this.subTaskDetails && this.subTaskDetails.preparerAttorneyId) {
                    this.petitionTaskForm.patchValue({ preparerAttorneyId: this.subTaskDetails.preparerAttorneyId });
                    this.userPreparerSelected();
                }
                if (this.subTaskDetails && this.subTaskDetails.lawFirmUsers) {
                    this.petitionTaskForm.patchValue({ lawFirmUsers: this.subTaskDetails.lawFirmUsers });
                    this.usersLawFrimSelected();
                }
            });
        }
        else {
            this.attorneyUsers = [];
            this.lawFirmUsersList = [];
        }
        sessionStorage.setItem("setPreparerAttorneyId", "undefined");
    }
    userPreparerSelected() {
        const id = this.petitionTaskForm.get('preparerAttorneyId').value;
        this.selectedPreparer = this.attorneyUsers.find(ele => ele.id === id);
        sessionStorage.setItem("setPreparerAttorneyId", this.selectedPreparer['id']);
    }
    usersLawFrimSelected() {
        const ids = this.petitionTaskForm.get('lawFirmUsers').value;
        this.selectedLawFirmUsers = ids.length ? this.lawFirmUsersList.filter(ele => ids.includes(ele.id)) : [];
        this.selectedLawFirmUsersTextArr = [];
        this.selectedLawFirmUsers.forEach((el) => {
            this.selectedLawFirmUsersTextArr.push(`${el.firstName} ${el.lastName}`);
        });
    }
    onPetitionerPreparerSelected() {
        const id = this.petitionTaskForm.get('immSpecialistId').value;
        this.selectedPetetionPreprarer = this.users.find(ele => ele.id === id);
    }
    ngOnDestroy() {
        if (this.ngUnsubscribe) {
            this.ngUnsubscribe.next();
            this.ngUnsubscribe.complete();
        }
        // if (this.petitionTaskForm) {
        //   for (const [key, value] of Object.entries(this.petitionTaskForm.controls)) {
        //     this.form.removeControl(key);
        //   }
        // }
        sessionStorage.setItem("setPreparerAttorneyId", "undefined");
    }
}
SubTaskPetitionDetailsComponent.ɵfac = function SubTaskPetitionDetailsComponent_Factory(t) { return new (t || SubTaskPetitionDetailsComponent)(i0.ɵɵdirectiveInject(i1$1.FormBuilder), i0.ɵɵdirectiveInject(SubTaskPetitionDetailsService), i0.ɵɵdirectiveInject(i3.ReferenceLibraryService), i0.ɵɵdirectiveInject(i1$1.FormGroupDirective)); };
SubTaskPetitionDetailsComponent.ɵcmp = i0.ɵɵdefineComponent({ type: SubTaskPetitionDetailsComponent, selectors: [["sub-task-petition-details-library"]], inputs: { templateTaskTypeId: "templateTaskTypeId", subTaskDetails: "subTaskDetails" }, features: [i0.ɵɵProvidersFeature([], [
            { provide: ControlContainer, useExisting: FormGroupDirective },
        ])], decls: 32, vars: 10, consts: [["formGroupName", "petitionTaskForm", 1, "col-md-12", "p-mt-2"], [1, "col-md-12"], [4, "ngIf"], ["class", "p-fluid p-formgrid p-grid", 4, "ngIf"], ["class", "p-grid dashed-line p-my-4", 4, "ngIf"], [1, "p-grid", "dashed-line", "p-my-4"], [1, "p-fluid", "p-formgrid", "p-grid"], [1, "p-col-4"], [1, "create-task-label", "required"], ["formControlName", "authorizedSignatoryId", "name", "authorizedSignatoryId", "optionLabel", "firstName", "optionValue", "id", "placeholder", "Select Signatory", 3, "options", "onChange"], ["pTemplate", "selectedItem"], ["pTemplate", "item"], ["class", "invalid-message", 4, "ngIf"], [1, "create-task-label"], ["type", "text", "readOnly", "", "name", "selectedDesignation", "formControlName", "selectedDesignation", 1, "form-control", "txt-comp"], ["formControlName", "immSpecialistId", "name", "immSpecialistId", "optionLabel", "firstName", "optionValue", "id", "placeholder", "Select Petitioner Preparer", "appendTo", "body", 3, "options", "onChange"], ["formArrayName", "questionAndResponseDTO", 4, "ngFor", "ngForOf"], ["formArrayName", "questionAndResponseDTO"], [3, "formGroupName"], [1, "p-grid"], ["name", "create-task-label question", 1, "p-col-9"], ["class", "p-col-1", 4, "ngIf"], ["class", "p-grid", 4, "ngIf"], ["class", "mt-3 p-col-12", 4, "ngIf"], [1, "p-col-1"], ["color", "primary", "name", "answer", "formControlName", "answer", 3, "toggleChange"], ["class", "p-col-5", 4, "ngIf"], ["class", "p-col-10", 4, "ngIf"], [1, "p-col-5"], ["styleClass", "create-task-input", "placeholder", "Enter", "formControlName", "additionalInfo", 1, "d-block", 3, "min", "max", "maxlength", "useGrouping"], [1, "invalid-message"], [1, "p-col-10"], ["rows", "3", "formControlName", "additionalInfo", "placeholder", "Enter", "pInputTextarea", "", "autoResize", "autoResize", 1, "create-task-textarea", "d-block"], [1, "mt-3", "p-col-12"], ["type", "text", "placeholder", "Enter", "formControlName", "additionalInfo", 1, "im-input", "mb-4"], [1, "p-col-12"], [1, "p-formgroup-inline"], [1, "p-field-checkbox"], ["name", "beneficiaryType", "value", "named", "formControlName", "beneficiaryType", "inputId", "named"], ["for", "named", 1, "create-task-label"], ["name", "beneficiaryType", "value", "unnamed", "formControlName", "beneficiaryType", "inputId", "unnamed"], ["for", "unnamed", 1, "create-task-label"], ["class", "p-col-4", 4, "ngIf"], ["formControlName", "foreignCompanyId", "name", "foreignCompanyId", "optionLabel", "companyName", "optionValue", "id", "placeholder", "Select", 3, "options", "onChange"], ["class", "p-error", 4, "ngIf"], [1, "p-error"], ["formControlName", "companyRelationCode", "name", "companyRelationCode", "optionLabel", "name", "optionValue", "code", "placeholder", "Select", 3, "options"], ["type", "text", "pInputText", "", "formControlName", "treatyCountry", 1, "form-control", "txt-comp", 3, "readonly"], ["formControlName", "attorneyId", "name", "attorneyId", "optionLabel", "attorneyName", "optionValue", "attorneyId", "placeholder", "Select attorney", 3, "options", "onChange"], ["formControlName", "preparerAttorneyId", "name", "preparerAttorneyId", "optionLabel", "firstName", "optionValue", "id", "placeholder", "Select Preparer", 3, "options", "onChange"], [1, "labelText"], [1, "p-col-12", "pl-0"], [1, "mt-2", "ml-2", "create-task-label", "label-cls"], [1, "row", "mt-1", "ml-2"], [1, "mt-2", "ml-1", "create-task-label"], ["formControlName", "preparerAttorneyId", "name", "preparerAttorneyId", "optionLabel", "firstName", "optionValue", "id", "placeholder", "Select", 3, "options", "onChange"], [1, "mt-2", "d-block", "create-task-label"], ["optionValue", "id", "formControlName", "lawFirmUsers", "appendTo", "body", "defaultLabel", "Select", "optionLabel", "firstName", 1, "w-100", 3, "options", "onChange"], ["pTemplate", "selectedItems"]], template: function SubTaskPetitionDetailsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 1);
        i0.ɵɵtemplate(3, SubTaskPetitionDetailsComponent_div_3_Template, 2, 1, "div", 2);
        i0.ɵɵtemplate(4, SubTaskPetitionDetailsComponent_div_4_Template, 14, 1, "div", 3);
        i0.ɵɵtemplate(5, SubTaskPetitionDetailsComponent_div_5_Template, 1, 0, "div", 4);
        i0.ɵɵtemplate(6, SubTaskPetitionDetailsComponent_div_6_Template, 4, 3, "div", 3);
        i0.ɵɵelement(7, "div", 5);
        i0.ɵɵelementStart(8, "div", 6);
        i0.ɵɵelementStart(9, "div", 7);
        i0.ɵɵelementStart(10, "label", 8);
        i0.ɵɵtext(11, "Signatory Name");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(12, "p-dropdown", 9);
        i0.ɵɵlistener("onChange", function SubTaskPetitionDetailsComponent_Template_p_dropdown_onChange_12_listener() { return ctx.userSelected(); });
        i0.ɵɵtemplate(13, SubTaskPetitionDetailsComponent_ng_template_13_Template, 1, 1, "ng-template", 10);
        i0.ɵɵtemplate(14, SubTaskPetitionDetailsComponent_ng_template_14_Template, 3, 1, "ng-template", 11);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(15, SubTaskPetitionDetailsComponent_span_15_Template, 2, 1, "span", 12);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(16, "div", 7);
        i0.ɵɵelementStart(17, "label", 13);
        i0.ɵɵtext(18, "Designation");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(19, "input", 14);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelement(20, "div", 5);
        i0.ɵɵtemplate(21, SubTaskPetitionDetailsComponent_div_21_Template, 12, 2, "div", 2);
        i0.ɵɵtemplate(22, SubTaskPetitionDetailsComponent_div_22_Template, 21, 3, "div", 2);
        i0.ɵɵelement(23, "div", 5);
        i0.ɵɵelementStart(24, "div", 6);
        i0.ɵɵelementStart(25, "div", 7);
        i0.ɵɵelementStart(26, "label", 8);
        i0.ɵɵtext(27, "Petitioner preparer name");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(28, "p-dropdown", 15);
        i0.ɵɵlistener("onChange", function SubTaskPetitionDetailsComponent_Template_p_dropdown_onChange_28_listener() { return ctx.onPetitionerPreparerSelected(); });
        i0.ɵɵtemplate(29, SubTaskPetitionDetailsComponent_ng_template_29_Template, 1, 1, "ng-template", 10);
        i0.ɵɵtemplate(30, SubTaskPetitionDetailsComponent_ng_template_30_Template, 3, 1, "ng-template", 11);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(31, SubTaskPetitionDetailsComponent_span_31_Template, 2, 1, "span", 12);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", !ctx.isOutsideImagility);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.fields.showBeneficiaryType);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.fields.showDividerBeforeForeignCompany);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.fields.showForeignCompany || ctx.fields.showRelationshipOfUSCompanyWithForeignCompany || ctx.fields.showTreatyCountry);
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("options", ctx.reviewUsersList);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.petitionTaskForm.get("authorizedSignatoryId").touched && (ctx.petitionTaskForm.get("authorizedSignatoryId").errors == null ? null : ctx.petitionTaskForm.get("authorizedSignatoryId").errors.required));
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("ngIf", ctx.isAttorneySelect);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.isAttorneySelect);
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("options", ctx.users);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.petitionTaskForm.get("immSpecialistId").touched && (ctx.petitionTaskForm.get("immSpecialistId").errors == null ? null : ctx.petitionTaskForm.get("immSpecialistId").errors.required));
    } }, directives: [i1$1.NgControlStatusGroup, i1$1.FormGroupName, i4.NgIf, i5.Dropdown, i1$1.NgControlStatus, i1$1.FormControlName, i6.PrimeTemplate, i1$1.DefaultValueAccessor, i4.NgForOf, i1$1.FormArrayName, i7.InputNumber, i1$1.MaxLengthValidator, i8.InputTextarea, i9.RadioButton, i10.InputText, i11.MultiSelect], styles: ["[_nghost-%COMP%]   .mat-slide-toggle.mat-checked[_ngcontent-%COMP%]    .mat-slide-toggle-bar:after{content:\"Yes\";font-size:50%;font-weight:700;color:#fff;position:absolute;left:4px;top:-5px}[_nghost-%COMP%]   .mat-slide-toggle[_ngcontent-%COMP%]:not(.mat-checked)    .mat-slide-toggle-bar:after{content:\"No\";font-size:50%;font-weight:700;color:#fff;position:absolute;left:21px;top:-5px}[_nghost-%COMP%]   .mat-slide-toggle[_ngcontent-%COMP%]   .mat-primary.mat-checked[_ngcontent-%COMP%]   .mat-slide-toggle-thumb[_ngcontent-%COMP%]{background-color:#30b1e1!important}  .mat-slide-toggle.mat-primary.mat-checked:not(.mat-disabled) .mat-slide-toggle-bar,   .mat-slide-toggle.mat-primary.mat-checked:not(.mat-disabled) .mat-slide-toggle-thumb{background-color:#30b1e1}.create-task-label[_ngcontent-%COMP%]{font-size:14px!important}input[readonly][_ngcontent-%COMP%]{background-color:#f1f1f1!important;border:1px solid #c3d0de!important;box-shadow:none!important;height:40px!important}.extra-ordinary-dropdown[_ngcontent-%COMP%]{display:grid}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SubTaskPetitionDetailsComponent, [{
        type: Component,
        args: [{
                selector: 'sub-task-petition-details-library',
                templateUrl: 'sub-task-petition-details.component.html',
                styleUrls: ['./sub-task-petition-details.component.scss'],
                viewProviders: [
                    { provide: ControlContainer, useExisting: FormGroupDirective },
                ]
            }]
    }], function () { return [{ type: i1$1.FormBuilder }, { type: SubTaskPetitionDetailsService }, { type: i3.ReferenceLibraryService }, { type: i1$1.FormGroupDirective }]; }, { templateTaskTypeId: [{
            type: Input
        }], subTaskDetails: [{
            type: Input
        }] }); })();

class SubTaskPetitionDetailsModule {
}
SubTaskPetitionDetailsModule.ɵfac = function SubTaskPetitionDetailsModule_Factory(t) { return new (t || SubTaskPetitionDetailsModule)(); };
SubTaskPetitionDetailsModule.ɵmod = i0.ɵɵdefineNgModule({ type: SubTaskPetitionDetailsModule });
SubTaskPetitionDetailsModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            PrimengLibraryModule,
            FormsModule,
            ReactiveFormsModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(SubTaskPetitionDetailsModule, { declarations: [SubTaskPetitionDetailsComponent], imports: [PrimengLibraryModule,
        FormsModule,
        ReactiveFormsModule], exports: [SubTaskPetitionDetailsComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SubTaskPetitionDetailsModule, [{
        type: NgModule,
        args: [{
                declarations: [SubTaskPetitionDetailsComponent],
                imports: [
                    PrimengLibraryModule,
                    FormsModule,
                    ReactiveFormsModule,
                ],
                exports: [SubTaskPetitionDetailsComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of sub-task-petition-details
 */

/**
 * Generated bundle index. Do not edit.
 */

export { SubTaskPetitionDetailsComponent, SubTaskPetitionDetailsModule, SubTaskPetitionDetailsService };
//# sourceMappingURL=sub-task-petition-details.js.map
